var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBy = function SvgBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M4.957 11.129 3.652 8.762l1.305-2.329 1.304 2.33-1.304 2.366ZM2.347 11.129 1.043 8.762l1.304-2.329 1.305 2.33-1.305 2.366ZM4.957 17.564l-1.305-2.366 1.305-2.33 1.304 2.33-1.304 2.366ZM2.347 17.564l-1.304-2.366 1.304-2.33 1.305 2.33-1.305 2.366ZM6.26 2.329l-.369-.66c-.662.393-1.283.847-1.856 1.355l.921 1.671L6.26 2.33ZM4.956 19.304l-.93 1.662c.571.51 1.192.964 1.854 1.357l.38-.69-1.304-2.329Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M7.304 15.13v7.916c1.442.614 3.029.954 4.695.954 5.16 0 9.559-3.256 11.254-7.826l-15.95-1.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M23.253 16.174c.482-1.3.746-2.706.746-4.174 0-6.627-5.372-12-12-12-1.666 0-3.253.34-4.695.954v15.22h15.949Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBy;